/* Copyright (c) yasc GmbH
 * ALL RIGHTS RESERVED
 * This software is protected by the inclusion of the above copyright
 * notice. This software may not be provided or otherwise made available
 * to, or used by, any other person. No title to or ownership of the
 * software is  hereby  transferred.
 * The information contained in this document is considered the
 * CONFIDENTIAL and PROPRIETARY information of yasc GmbH and may
 * not be disclosed or discussed with anyone who is not employed by
 * yasc GmbH, unless the individual/company
 * (i) has an express need to know such information, and
 * (ii) disclosure of information is subject to the terms of a duly
 * executed Confidentiality and Non-Disclosure Agreement between
 * yasc GmbH and the individual/company.
 */
import {ApiV0} from "../../api.v0";
import {RestApiService} from "../../../rest-api.service";
import {Observable} from "rxjs";
import {BaseCollectionModel, FileContainerReq, FileUploadRes} from '@yasc/yasc-material-components';
import {HttpParams} from '@angular/common/http';

export class ApiV0File {
    segment = '/file';

    constructor(
        v0: ApiV0,
        private rest: RestApiService,
    ) {
        this.segment = v0.segment + this.segment;
    }

    uploadFile(dto: FileContainerReq): Observable<FileUploadRes> {
        return this.rest.post<FileContainerReq, FileUploadRes>(
            `${this.segment}/`,
            FileUploadRes,
            dto
        );
    }

    uploadFiles(dto: FileContainerReq[]): Observable<BaseCollectionModel<FileUploadRes>> {
        return this.rest.post<FileContainerReq[], BaseCollectionModel<FileUploadRes>>(
            `${this.segment}/bulk`,
            BaseCollectionModel<FileUploadRes>,
            dto
        );
    }

    removeFile(att: FileUploadRes): Observable<FileContainerReq> {
        return this.rest.delete<FileContainerReq>(
            `${this.segment}/${att.id}`,
        );

    }

    updateFile(file: FileUploadRes): Observable<FileUploadRes> {
        return this.rest.patch<FileUploadRes, FileUploadRes>(
            `${this.segment}/${file.id}`,
            FileUploadRes,
            file
        );
    }

    downloadFile(url: string, qp: Record<string, any> = {}): void {
        let params = new HttpParams();

        Object.entries(qp).forEach(([key, value]) => {
            if (value === null || value === undefined || value === '') {
                return;
            }

            if (Array.isArray(value)) {
                value
                    .filter(x => x !== null && x !== undefined && x !== '')
                    .forEach(x => params = params.append(key, String(x)));
                return;
            }

            params = params.set(key, String(value));
        });

        this.rest.http.get(url, {
            observe: 'response',
            responseType: 'blob',
            params
        }).subscribe(response => {
            const contentDisposition = response.headers.get('Content-Disposition');
            const headerFileName = response.headers.get('x-file-name');

            let fileName = headerFileName || 'download';

            if (contentDisposition) {
                const utf8Match = contentDisposition.match(/filename\*=UTF-8''(.+)/);
                const plainMatch = contentDisposition.match(/filename="?([^"]+)"?/);

                if (utf8Match?.[1]) {
                    fileName = decodeURIComponent(utf8Match[1]);
                } else if (plainMatch?.[1]) {
                    fileName = plainMatch[1];
                }
            }

            const body = response.body as Blob;
            const blob = new Blob([body], {type: body.type || 'application/pdf'});
            const objectUrl = URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = objectUrl;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);

            URL.revokeObjectURL(objectUrl);
        });
    }


}
